<template>
    <div v-if="cartBadgeCount > 0" class="position-absolute basketcounter-big d-flex justify-content-center align-items-center" :class="'basketcounter--'+theme">
        <span>{{cartBadgeCount}}</span>
    </div>
</template>

<script>
import {eventBus} from 'fire-vue-core';
import gql from 'fake-tag';
export default {
    name: 'basketcounter',
    data: () => ({
        cartBadgeCount: 0,
    }),
    directives: {},
    mixins: [],
    props: {
        theme: String,
    },
    watch: {

    },
    created()
    {

    },
    destroyed()
    {

    },
    mounted()
    {
        this.getBasketProducts();
        eventBus.$on('CallGetBasketProducts', () =>
            {
                this.getBasketProducts();
            }
        )
    },
    methods: {
        getBasketProducts() {
            const body = JSON.stringify({
                query: gql`query {
                            basket {
                                positions {
                                    products {
                                        quantity
                                    }
                                }
                            }
                        }`
            });

            fetch(graphqlApi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': yii.getCsrfToken()
                },
                body
            })
                .then(res => res.json())
                .then(res => {
                    let cartBadgeCountTemp = 0;
                    res.data.basket.positions.forEach(function(item){
                        cartBadgeCountTemp = cartBadgeCountTemp + item.products[0].quantity;
                    });
                    this.cartBadgeCount = cartBadgeCountTemp;
                });
        },
    }
};
</script>

<style lang="scss">
    @import "frontend/styles/framework";
    .basketcounter-big{
        &--white{
            background-color: $secondary-white !important;
            color: $white;
        }
        &--dark{
            background-color: $secondary-dark !important;
            color: $black;
        }
        top: -6px;
        left: 10px;
        font-size: 0.7em;
        width: 15px;
        height: 15px;
        border-radius: 50%;
    }
</style>